import {
  Avatar,
  Card,
  Col,
  Divider,
  Row,
  Space,
  Spin,
  Table,
  Typography,
} from "antd";
import { Gauge, Medal, TrendingUpDown, UserRound } from "lucide-react";
import React, { useEffect, useState } from "react";
import { getTrainingBoot } from "services/aquatic/aquatic-service";
import {
  ColumnsUserAquaBoot,
  ColumnsUserCmj,
  ColumnsUserComparationAqua,
} from "../load-control/columns-table";
import { FONT } from "constants/index";
import { notificationErroInternal } from "util/api-utils";
import { chartBarOneLine, chartLinerDot } from "../load-control/load-control-drawer-charts";

const { Text } = Typography;

const FormTrainningBootAqua = ({ user }) => {
  const [loading, setLoading] = useState(false);
  const [imgAvatar, setImgAvatar] = useState(null);
  const [userControl, setUserControl] = useState({});
  const [data, setDataDrawer] = useState([]);

  useEffect(() => {
    if (user?.id) {
      setLoading(true);
      getData();
    }
  }, [user]);

  function getData() {
    getTrainingBoot(user?.id)
      .then((res) => {
        setUserControl(res);
        const dataResult = res.trainingGrouped?.map((obj) => ({
          ...obj,
          changeActualComp: changeActual,
        }));
        setDataDrawer(dataResult);
        setImgAvatar(res.img);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  const changeActual = function (row) {
    setLoading(true);
    setTimeout(() => {
      let newUserSelected = userControl;
      newUserSelected.trainingActual = row;
      setUserControl(newUserSelected);
      setLoading(false);
    }, 300);
  };

  return (
    <Spin size="large" spinning={loading}>
      <Row gutter={16} style={{ textAlign: "center", marginBottom: "30px" }}>
        <Col span={24}>
          <Avatar src={imgAvatar} icon={<UserRound size={120} />} size={120} />
        </Col>
      </Row>
      <Row gutter={16} style={{ marginTop: "15px" }}>
        <Space direction="vertical" size={"small"}>
          <Card
            id="card-table"
            title={
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ flex: 1 }}>
                  <Medal
                    size={18}
                    style={{ marginBottom: "-4px", marginRight: "10px" }}
                  />
                  <Text style={{ fontSize: "15px", fontFamily: FONT }}>
                    Histórico de Treinos
                  </Text>
                </div>
              </div>
            }
            bordered={false}
          >
            <Table
              columns={ColumnsUserComparationAqua()}
              dataSource={data}
              pagination={{ pageSize: 2, showSizeChanger: false }}
              locale={{
                emptyText: "Sem registro",
              }}
            />
          </Card>
        </Space>
      </Row>
      <Divider />
      <Row gutter={16} style={{ marginTop: "15px" }}>
        <Col span={24} style={{ marginTop: "10px" }}>
          <Card
            title={
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ flex: 1 }}>
                  <Gauge
                    size={18}
                    style={{ marginBottom: "-4px", marginRight: "10px" }}
                  />
                  <Text style={{ fontSize: "14px", fontFamily: FONT }}>
                    Treinos
                  </Text>
                </div>
              </div>
            }
            style={{ width: "100%" }}
          >
            {chartBarOneLine(
              userControl.trainingActual?.training ?? [],
              "date",
              "load",
              "Metragem",
              "loadFinal",
              "Esforço",
              5
            )}
          </Card>
        </Col>
      </Row>
      <Divider />
      <Row gutter={16} style={{ marginTop: "15px" }}>
        <Col span={24} style={{ marginTop: "10px" }}>
          <Card
            id="card-table"
            title={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: 1 }}>
                  <TrendingUpDown
                    size={18}
                    style={{ marginBottom: "-4px", marginRight: "10px" }}
                  />
                  <Text style={{ fontSize: "15px", fontFamily: FONT }}>
                    Treinos
                  </Text>
                </div>
              </div>
            }
            bordered={false}
          >
            <Table
              columns={ColumnsUserAquaBoot()}
              dataSource={userControl.trainingActual?.training ?? []}
              pagination={{ pageSize: 5, showSizeChanger: false }}
              size="small"
              locale={{
                emptyText: "Sem registro",
              }}
              
            />
          </Card>
        </Col>
      </Row>
      <Divider />
    </Spin>
  );
};

export default FormTrainningBootAqua;
